import { IChildOrganisation, IPEPHealthService } from '@liquid-state/pephealth-client';

export type DirectChildOrganisation = IChildOrganisation;

export const listDirectChildOrganisations = (
  service: IPEPHealthService,
): Promise<DirectChildOrganisation[]> => service.listChildOrganisations();

export const getDirectChildOrganisation = (
  service: IPEPHealthService,
  organisationSlug: string,
): Promise<DirectChildOrganisation> => service.getChildOrganisation(organisationSlug);
